/**
 * Classifica «Top Clienti per Fatturato» della pagina Clienti, calcolata dalle
 * fatture dell'elenco. DBT-053 (decisione di Vale del 13/10): le fatture
 * ANNULLATE non contano. (Il resto del calcolo è invariato: somma del totale.)
 */
export function classificaClienti(fatture, limite = 8) {
  const map = {};
  for (const f of fatture || []) {
    if (f.stato === 'annullata') continue;
    const nome = f.cliente_nome || f.cliente_nome_snapshot;
    if (nome) map[nome] = (map[nome] || 0) + parseFloat(f.totale || 0);
  }
  const sorted = Object.entries(map).sort(([, a], [, b]) => b - a).slice(0, limite);
  const totale = sorted.reduce((s, [, v]) => s + v, 0);
  return sorted.map(([nome, valore], i) => ({
    pos: i + 1, nome, valore: Math.round(valore),
    pct: totale > 0 ? (valore / totale * 100).toFixed(2) : '0',
  }));
}
